<template>
    <div class="calendar__detail--wrapper bg-white border-radius-10-px dashboard-calender-component-main"> 
        <div class="calendar__component--header d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">   
                <div class="d-flex align-items-center home-month-calendar__nav" :style="[{marginRight : clientWidth > 767 ? '40px' : '15px' }]">
                    <button type="button" class="home-month-calendar__nav-btn" @click="changeMonth(-1)">‹</button>
                    <strong class="home-month-calendar__title">{{ monthTitle }}</strong>
                    <button type="button" class="home-month-calendar__nav-btn" @click="changeMonth(1)">›</button>
                    <DueDateCompo
                        :ref="'dueDate'"
                        class="due-date-home-cal"
                        id="due-date-home-calender"
                        :allowTillCurrentDate="true"
                        :useCustomTrigger="true"
                        :isShowDateAndicon="true"
                        :displyDate="new Date(dateValue).getTime()"
                        @SelectedDate="($event) => updateDueDate($event)"
                        :position="`right`"
                        :autoposition="true"
                    />
                </div>
            </div>
            <div class="d-flex align-items-center">
                <span class="day__status font-size-14 gray81 cursor-pointer lable-status-hover" :style="[{marginLeft : clientWidth > 767 ? '20px' : '10px' }]" @click="updateDueDate({dateVal:new Date()})">{{$t('Home.Today')}}</span>
            </div>
        </div> 
        <div class="calendar__main-component home-month-calendar">
            <!-- Loading Skeleton -->
            <div class="p-10px" v-if="loading">
                <div class="home-month-calendar__grid">
                    <div class="home-month-calendar__cell home-month-calendar__cell--loading" v-for="index in 35" :key="index">
                        <SkelatonVue :style="{width: '32px', height: '10px', margin: '0 0 8px'}" :class="{}"/>
                        <SkelatonVue :style="{width: '80%', height: '12px', margin: '0 0 6px'}" :class="{}"/>
                        <SkelatonVue :style="{width: '65%', height: '12px', margin: '0'}" :class="{}"/>
                    </div>
                </div>
            </div>

            <div class="home-month-calendar__body" v-else>
                <div class="home-month-calendar__weekdays">
                    <span v-for="day in weekDays" :key="day">{{ day }}</span>
                </div>
                <div class="home-month-calendar__grid">
                    <div
                        v-for="day in calendarDays"
                        :key="day.key"
                        class="home-month-calendar__cell"
                        :class="{
                            'home-month-calendar__cell--muted': !day.isCurrentMonth,
                            'home-month-calendar__cell--today': day.isToday,
                            'home-month-calendar__cell--selected': day.isSelected
                        }"
                        @click="dateValue = new Date(day.date)"
                    >
                        <div class="home-month-calendar__date-row">
                            <span class="home-month-calendar__date">{{ day.dayNumber }}</span>
                            <span v-if="day.tasks.length" class="home-month-calendar__count">{{ day.tasks.length }}</span>
                        </div>

                        <button
                            v-for="task in day.tasks.slice(0, 3)"
                            :key="task._id"
                            type="button"
                            class="home-month-calendar__task"
                            @click.stop.prevent="openInNewTab(task)"
                        >
                            <span class="home-month-calendar__task-dot" :style="{ backgroundColor: getStatusColor(task.statusKey) }"></span>
                            <span class="home-month-calendar__task-name">{{ task.TaskName }}</span>
                        </button>

                        <span v-if="day.tasks.length > 3" class="home-month-calendar__more">+{{ day.tasks.length - 3 }} more</span>
                    </div>
                </div>
                <div v-if="!searchResults.length" class="text-center no-task-found">
                    {{$t('Home.no_task_found')}}
                </div>
            </div>
        </div>

        <TaskDetail 
            v-if="isTaskDetail" 
            :companyId="companyId" 
            :projectId="projectId" 
            :sprintId="sprintId"
            :taskId="taskId" 
            :isTaskDetailSideBar="isTaskDetail" 
            @toggleTaskDetail="toggleTaskDetail" 
            :zIndex="5" 
        />
    </div>
</template>

<script setup>
/* eslint-disable */
import { defineProps, ref, onMounted, inject, watch, nextTick, provide, computed, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import SkelatonVue from '@/components/atom/Skelaton/Skelaton.vue';
import DueDateCompo from '@/components/molecules/DueDateCompo/DueDateCompo.vue';
import TaskDetail from '@/views/TaskDetail/TaskDetail.vue';
import { apiRequest } from "@/services";
import * as env from '@/config/env';
import { buildFilterQuery, teamIdToUserId } from "@/composable/commonFunction";

const { getters } = useStore();
const teamsArr = getters["settings/teams"];
const TaskStatusArray = computed(() => getters["settings/AllTaskStatus"]);

const props = defineProps({
    allProjectsArrayFilter: {
        type: Array,
        required: true
    },
    updatedObject: {
        type: Object,
        default: () => { }
    },
    cardData: {
        type: Object,
        default: () => { }
    },
    filterData: {
        type: Array,
        default: () => { }
    },
});

const userId = inject("$userId");
const companyId = inject("$companyId");
const clientWidth = inject("$clientWidth");

const allProjects = ref(props.allProjectsArrayFilter);
const personalProjectId = ref("");
const filterData = ref(JSON.parse(JSON.stringify(props.filterData)));
const filterQuery = ref([]);
const searchResults = ref([]);
const pageNumber = ref(1);
const loading = ref(false);
const timer = ref(null);
const memorizationArray = ref([]);
const dateValue = ref(new Date());
const skip = ref(0);
const limit = ref(500);
const projectId = ref(null);
const sprintId = ref(null);
const taskId = ref(null);
const isTaskDetail = ref(false);
const cardObject = ref(props.cardData);
let requestSeq = 0;
const weekDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const findParticularProject = (id) => allProjects.value.find((xt) => xt._id === id) || {};

const getStatusColor = (statusKey) => {
    const statusArray = TaskStatusArray.value?.settings || [];
    const status = statusArray.find((s) => s.key === statusKey);
    return status?.textColor || '#8e8e93';
};

const monthTitle = computed(() => {
    return new Date(dateValue.value).toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric'
    });
});

const toDateKey = (date) => {
    const value = new Date(date);
    value.setHours(0, 0, 0, 0);
    return value.toISOString();
};

const getTaskDate = (task) => {
    return task?.DueDate || task?.startDate || task?.createdAt;
};

const monthBounds = computed(() => {
    const current = new Date(dateValue.value);
    const monthStart = new Date(current.getFullYear(), current.getMonth(), 1);
    const monthEnd = new Date(current.getFullYear(), current.getMonth() + 1, 0);
    monthStart.setHours(0, 0, 0, 0);
    monthEnd.setHours(23, 59, 59, 999);

    return { monthStart, monthEnd };
});

const tasksByDay = computed(() => {
    return searchResults.value.reduce((acc, task) => {
        const taskDate = getTaskDate(task);
        if (!taskDate) {
            return acc;
        }

        const key = toDateKey(taskDate);
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(task);
        return acc;
    }, {});
});

const calendarDays = computed(() => {
    const { monthStart, monthEnd } = monthBounds.value;
    const firstGridDate = new Date(monthStart);
    const mondayOffset = (firstGridDate.getDay() + 6) % 7;
    firstGridDate.setDate(firstGridDate.getDate() - mondayOffset);

    const lastGridDate = new Date(monthEnd);
    const sundayOffset = 6 - ((lastGridDate.getDay() + 6) % 7);
    lastGridDate.setDate(lastGridDate.getDate() + sundayOffset);

    const selectedKey = toDateKey(dateValue.value);
    const todayKey = toDateKey(new Date());
    const days = [];
    const cursor = new Date(firstGridDate);

    while (cursor <= lastGridDate) {
        const key = toDateKey(cursor);
        days.push({
            key,
            date: new Date(cursor),
            dayNumber: cursor.getDate(),
            isCurrentMonth: cursor.getMonth() === monthStart.getMonth(),
            isToday: key === todayKey,
            isSelected: key === selectedKey,
            tasks: tasksByDay.value[key] || []
        });
        cursor.setDate(cursor.getDate() + 1);
    }

    return days;
});

watch(() => props.updatedObject, (newVal) => {
    if (!newVal) {
        return;
    }

    const taskDate = getTaskDate(newVal);
    const { monthStart, monthEnd } = monthBounds.value;
    const findIndex = searchResults.value.findIndex((ele) => ele._id === newVal._id);

    if (taskDate && new Date(taskDate).getTime() >= monthStart.getTime() && new Date(taskDate).getTime() <= monthEnd.getTime()) {
        if (findIndex === -1) {
            searchResults.value.unshift(newVal);
        } else {
            searchResults.value.splice(findIndex, 1, newVal);
        }
    } else if (findIndex !== -1) {
        searchResults.value.splice(findIndex, 1);
    }
});

// Open task detail
const openInNewTab = (task) => {
    projectId.value = task.ProjectID;
    sprintId.value = task.sprintId;
    taskId.value = task._id;
    isTaskDetail.value = true;
};

// Toggle task detail
const toggleTaskDetail = (task, close = false) => {
    isTaskDetail.value = false;
    if (close === true) {
        return;
    }
    projectId.value = '';
    sprintId.value = '';
    taskId.value = '';
    nextTick(() => {
        openInNewTab(task);
    });
};
provide('toggleTaskDetail', toggleTaskDetail);

// Search tasks
const getSelectedProjectIds = () => {
    const selectedProjectIds = Array.isArray(cardObject.value?.projectId)
        ? cardObject.value.projectId.filter(Boolean)
        : [];

    return Array.from(new Set([
        ...(selectedProjectIds.length
            ? selectedProjectIds
            : (allProjects.value || []).map((project) => project?._id).filter(Boolean)),
        personalProjectId.value,
    ].filter(Boolean)));
};

const loadPersonalWorkspaceProject = async () => {
    if (!userId.value || personalProjectId.value) return;

    try {
        const response = await apiRequest("get", `${env.PERSONAL_WORKSPACE}?userId=${userId.value}`);
        const project = response?.data?.data?.project || {};
        if (!project?._id) return;

        personalProjectId.value = project._id;
    } catch (error) {
        console.error("ERROR loading personal workspace for calendar: ", error);
    }
};

const syncFilterQuery = (data = []) => {
    const filters = Array.isArray(data) ? data : Object.values(data || {});
    filterQuery.value = filters.length ? buildFilterQuery(filters, userId.value) : [];
};

const searchMongoTasks = (date = null, reset = true) => {
    try {
        const projectIDs = getSelectedProjectIds();
        if (!projectIDs.length) {
            searchResults.value = [];
            loading.value = false;
            return;
        }

        if (reset) {
            searchResults.value = [];
            loading.value = true;
        }

        const activeDate = date == null ? new Date(dateValue.value) : new Date(date);
        let startDate = new Date(activeDate.getFullYear(), activeDate.getMonth(), 1).setHours(0, 0, 0, 0);
        let endDate = new Date(activeDate.getFullYear(), activeDate.getMonth() + 1, 0).setHours(23, 59, 59, 999);

        let queryAndConditions = [
            {
                objId: {
                    CompanyId: companyId.value,
                },
            },
            { deletedStatusKey: 0 },
            {
                ProjectID: {
                    objId: { $in: projectIDs },
                },
            },
            ...(filterQuery.value && typeof filterQuery.value === 'object'
                ? Object.entries(filterQuery.value).map(([key, value]) => ({ [key]: value }))
                : [])
        ];

        let obj = [
            {
                $match: {
                    $and: queryAndConditions,
                    $or: [
                        { startDate: { dbDate: { $gte: startDate, $lte: endDate } } },
                        { DueDate: { dbDate: { $gte: startDate, $lte: endDate } } },
                        {
                            $and: [
                                { DueDate: { dbDate: { $gte: startDate } } },
                                { startDate: { dbDate: { $lte: endDate } } }
                            ]
                        }
                    ]
                }
            },
            {
                $lookup: {
                    from: 'folders',
                    localField: 'folderObjId',
                    foreignField: '_id',
                    as: 'folderArray',
                    pipeline: [
                        {
                            $project: {
                                name: 1
                            }
                        }
                    ],
                }
            },
            {
                $lookup: {
                    from: 'sprints',
                    localField: 'sprintId',
                    foreignField: '_id',
                    as: 'sprintArray',
                    pipeline: [
                        {
                            $project: {
                                name: 1,
                                folderId: 1
                            }
                        }
                    ],
                }
            },
            {
                $unwind: '$sprintArray'
            },
            {
                $unwind: { path: '$folderArray', preserveNullAndEmptyArrays: true }
            },
            { $sort: { DueDate: 1, startDate: 1, _id: 1 } },
            { $limit: limit.value }
        ];
        obj = teamIdToUserId(obj, teamsArr);

        const currentSeq = ++requestSeq;

        debouncer(500).then(() => {
            apiRequest('post', `${env.TASK}/find`, { findQuery: obj }).then((response) => {
                if (currentSeq !== requestSeq) {
                    return;
                }
                if (response.status !== 200) {
                    loading.value = false;
                    searchResults.value = [];
                    return;
                }
                let result = response.data;
                if (!result.length || result.length === 0) {
                    loading.value = false;
                    if (reset) {
                        searchResults.value = [];
                    }
                    return;
                }
                searchResults.value = result;
                
                let count = 0;
                const updateTask = async (ele) => {
                    if (count >= searchResults.value.length) {
                        return;
                    } else {
                        if (ele.parentTaskName === undefined && !ele.isParentTask) {
                            let dataVal = await getSubTaskData(ele.ParentTaskId);
                            ele.parentTaskName = dataVal ? dataVal.TaskName : '';
                            count++;
                            updateTask(searchResults.value[count]);
                        } else {
                            count++;
                            updateTask(searchResults.value[count]);
                        }
                    }
                };
                updateTask(searchResults.value[count]);
                loading.value = false;
            })
            .catch((error) => {
                loading.value = false;
                console.error("ERROR in search tasks: ", error);
            });
        });
    } catch (error) {
        loading.value = false;
        console.error("ERROR in search tasks: ", error);
    }
};

// Get subtask data
const getSubTaskData = async (id1) => {
    const query = [
        {
            "$match": {
                objId: {
                    _id: id1
                }
            }
        }
    ];

    const findIndex = memorizationArray.value.findIndex((ele) => ele._id === id1);
    if (findIndex === -1) {
        try {
            const response = await apiRequest('post', `${env.TASK}/find`, { findQuery: query });
            if (response.status === 200) {
                memorizationArray.value.push({ ...response.data[0] });
                return { ...response.data[0] };
            } else {
                console.error(`ERROR: ${response.status} - ${response.data.message}`);
                return null;
            }
        } catch (error) {
            console.error("Error fetching subtask data:", error);
            return null;
        }
    } else {
        return memorizationArray.value[findIndex];
    }
};

const updateDueDate = (event) => {
    if (new Date(dateValue.value).toLocaleDateString() === new Date(event.dateVal).toLocaleDateString()) {
        return;
    }
    dateValue.value = new Date(event.dateVal);
    searchMongoTasks(dateValue.value, true);
};

const changeMonth = (step) => {
    const nextMonth = new Date(dateValue.value);
    nextMonth.setMonth(nextMonth.getMonth() + step, 1);
    dateValue.value = nextMonth;
    searchMongoTasks(nextMonth, true);
};

function debouncer(timeout = 1000) {
    return new Promise((resolve) => {
        if (timer.value) {
            clearTimeout(timer.value);
        }
        timer.value = setTimeout(() => {
            resolve();
        }, timeout);
    });
}

onMounted(async () => {
    syncFilterQuery(filterData.value);
    await loadPersonalWorkspaceProject();
    searchMongoTasks();
});

// Watch for changes in cardData prop
watch(() => props.cardData, (newValue) => {
    cardObject.value = newValue;
    searchMongoTasks(new Date(dateValue.value), true);
}, { deep: true });

// Watch for changes in advance filter prop
watch(() => props.filterData, (newValue) => {
    syncFilterQuery(newValue);
    searchMongoTasks();
}, { deep: true });

watch(() => props.allProjectsArrayFilter, (newValue) => {
    allProjects.value = Array.isArray(newValue) ? newValue : [];
    searchMongoTasks(new Date(dateValue.value), true);
}, { deep: true });

watch(() => userId.value, async (newValue, oldValue) => {
    if (!newValue || newValue === oldValue) return;
    personalProjectId.value = "";
    await loadPersonalWorkspaceProject();
    searchMongoTasks(new Date(dateValue.value), true);
});

onBeforeUnmount(() => {
    requestSeq += 1;
    if (timer.value) {
        clearTimeout(timer.value);
    }
});
</script>

<style scoped>
@import '../css/style.css';
.task-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0;
}

.project-group {
    border-radius: 8px;
    border: 1px solid #f2f2f7;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 8px;
    gap: 4px;
}

.project-name {
    font-family: Inter, sans-serif;
    font-size: 12px;
    line-height: 18px;
    color: #8e8e93;
    margin-bottom: 2px;
}

.calendar-item {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 2px 0;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.15s ease;
}

.calendar-item:hover {
    background-color: rgba(0, 0, 0, 0.03);
}

.task-row {
    align-self: stretch;
    display: flex;
    align-items: center;
    gap: 6px;
}

.task-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    flex-shrink: 0;
}

.status-square {
    width: 10px;
    height: 10px;
    border-radius: 2px;
    background-color: #8e8e93;
}

.task-title {
    height: 24px;
    display: flex;
    align-items: center;
    gap: 4px;
    flex: 1;
    min-width: 0;
}

.subtask-icon {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
}

.task-name {
    font-family: Inter, sans-serif;
    font-size: 12px;
    line-height: 18px;
    color: #141414;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.no-task-found {
    font-family: Inter, sans-serif;
    font-size: 12px;
    color: #8e8e93;
    padding: 20px;
}

.home-month-calendar {
    padding: 0 10px 10px;
}

.home-month-calendar__nav {
    gap: 8px;
}

.home-month-calendar__nav-btn {
    width: 28px;
    height: 28px;
    border: 1px solid #dfe1e6;
    border-radius: 6px;
    background: #fff;
    color: #172b4d;
    cursor: pointer;
    font-size: 18px;
    line-height: 1;
}

.home-month-calendar__title {
    min-width: 132px;
    font-size: 14px;
    color: #172b4d;
}

.home-month-calendar__body {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.home-month-calendar__weekdays,
.home-month-calendar__grid {
    display: grid;
    grid-template-columns: repeat(7, minmax(92px, 1fr));
}

.home-month-calendar__weekdays {
    flex: 0 0 auto;
    border: 1px solid #eef0f4;
    border-bottom: 0;
    border-radius: 8px 8px 0 0;
    background: #f7f8fa;
}

.home-month-calendar__weekdays span {
    padding: 8px;
    font-size: 11px;
    font-weight: 600;
    color: #6b778c;
    text-align: center;
}

.home-month-calendar__grid {
    flex: 1;
    min-height: 0;
    overflow: auto;
    border-left: 1px solid #eef0f4;
    border-top: 1px solid #eef0f4;
}

.home-month-calendar__cell {
    min-height: 96px;
    padding: 6px;
    border-right: 1px solid #eef0f4;
    border-bottom: 1px solid #eef0f4;
    background: #fff;
    overflow: hidden;
}

.home-month-calendar__cell--muted {
    background: #fafbfc;
}

.home-month-calendar__cell--today {
    box-shadow: inset 0 0 0 1px #0b72e7;
}

.home-month-calendar__cell--selected .home-month-calendar__date {
    background: #0b72e7;
    color: #fff;
}

.home-month-calendar__cell--loading {
    min-height: 72px;
}

.home-month-calendar__date-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    margin-bottom: 5px;
}

.home-month-calendar__date {
    width: 22px;
    height: 22px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 600;
    color: #172b4d;
}

.home-month-calendar__count {
    height: 18px;
    min-width: 18px;
    padding: 0 5px;
    border-radius: 9px;
    background: #eef6ff;
    color: #0b72e7;
    font-size: 11px;
    line-height: 18px;
    text-align: center;
}

.home-month-calendar__task {
    width: 100%;
    min-width: 0;
    height: 22px;
    display: flex;
    align-items: center;
    gap: 5px;
    border: 0;
    border-radius: 4px;
    background: #f4f5f7;
    padding: 0 5px;
    margin-bottom: 4px;
    cursor: pointer;
}

.home-month-calendar__task:hover {
    background: #e9f2ff;
}

.home-month-calendar__task-dot {
    width: 7px;
    height: 7px;
    border-radius: 2px;
    flex: 0 0 auto;
}

.home-month-calendar__task-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #172b4d;
    font-size: 11px;
    text-align: left;
}

.home-month-calendar__more {
    display: block;
    padding-left: 2px;
    color: #6b778c;
    font-size: 11px;
}

.status-in-progress {
    background-color: #ff8d28;
}

.status-in-review {
    background-color: #6155f5;
}

.status-backlog {
    background-color: #8e8e93;
}

.status-done {
    background-color: #34c759;
}
</style>
